
$(document).ready(function(e){
	if ($('.field.add-contacts').length > 0){

		var checkbox = $('.field.add-contacts input.checkbox');
		var add_button = $('.add-contacts.toggle-fields');

		checkbox.each(function(){
			var dom = $(this);
			var dependents = dom.parent().next('.contact-fields');
			var my_button = dom.parent().prev('.add-contacts.toggle-fields');

			// No valid data, so we can just stop here
			// This has a nice bonus of not binding any events for leaner performance
			if (!dependents || dependents == ""){
				return;
			} else {
				// on load...
				if(dom.is(":checked")){
					// if the checkbox is checked, hide the additional fields
					dependents.hide();
					RequireFields(dependents,false);
				}else {
					// if it's unchecked, show em
					dependents.show();
					RequireFields(dependents,true);
				}

				// on change...
				dom.on('change', function(e){
					if(dom.is(":checked")){
						// if the checkbox is checked, hide the additional fields
						dependents.hide();
						RequireFields(dependents,false);
						// and update the button
						my_button.removeClass('open');
					}else {
						// if it's unchecked, show em
						dependents.show();
						RequireFields(dependents,true);
						my_button.addClass('open');
					}
				});
			}
		});

		add_button.each(function(){
			var dom = $(this);
			var my_checkbox = dom.next('.field.add-contacts').find('input.checkbox');
			var dependents = dom.next('.field.add-contacts').next('.contact-fields');
			
			// No valid data, so we can just stop here
			// This has a nice bonus of not binding any events for leaner performance
			if (!dependents || dependents == ""){
				return;
			} else {
				// on change...
				dom.on('click', function(e){
					if(dom.hasClass('open')){
						// if the button is open, hide the additional fields...
						dependents.hide();
						RequireFields(dependents,false);
						// uncheck the checkbox...
						my_checkbox.prop("checked", true);
						// and remove the "open" class
						dom.removeClass('open');
					}else {
						// if the button is open, hide the additional fields...
						dependents.show();
						RequireFields(dependents,true);
						// check the checkbox...
						my_checkbox.prop("checked", false);
						// and add the "open" class
						dom.addClass('open');
					}
				});
			}
		});

		function RequireFields(field_container, required){
			var fields = field_container.find('.conditionally-required');

			if(required){
				fields.each(function(){
					$(this).attr('required','required');
				});
			}else {
				fields.each(function(){
					$(this).removeAttr('required');
				});
			}

			
		}

	}
});